import React, { useEffect, useState } from "react";
import Select from "react-select";
import apiHandler from "../../common/api";
import moment from "moment";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { dateFormat } from "../../common/common";
import DatePickup from "../DatePickup/DatePickup";

const BusinessHoursByDate = ({
  minHoursDropdown,
  userData,
  businessId,
  getStaffWiseScheduleRefresh,
  isDisable,
}) => {
  const [scheduleList, setScheduleList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const today = moment().day();
  const [formData, setFormData] = useState({
    id: 0,
    date: moment().format("YYYY-MM-DD"),
    startTime: "09:00",
    endTime: "17:00",
    isDayOff: 0,
    dayId: today,
  });

  const MySwal = withReactContent(Swal);
  const toggleModal = () => {
    setIsOpen(!isOpen);
    setFormData({
      id: 0,
      date: moment().format("YYYY-MM-DD"),
      startTime: "09:00",
      endTime: "17:00",
      isDayOff: 0,
      dayId: today,
    });
  };

  const hadleReset = () => {
    setFormData({   id: 0,
      date: moment().format("YYYY-MM-DD"),
      startTime: "09:00",
      endTime: "17:00",
      isDayOff: 0,
      dayId: today, });
  };

  console.log(formData, "bookinghoursbydate");
  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/businessHoursByDateList?businessId=${businessId}`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setScheduleList(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, []);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleBusinessHoursByDateSubmit = async () => {
    if (!formData.date) {
      alert("Please select a date.");
      return;
    }

    if (!formData.isDayOff && (!formData.startTime || !formData.endTime)) {
      alert("Please select both start and end times.");
      return;
    }

    if (
      !formData.isDayOff &&
      formData.startTime.value >= formData.endTime.value
    ) {
      alert("End time must be after start time.");
      return;
    }

    if (formData.id !== null && formData.id !== 0) {
      // Edit existing entry
      setScheduleList((prev) =>
        prev.map((item) => (item.id === formData.id ? { ...formData } : item))
      );
    } else {
      // Add new entry
      setScheduleList([...scheduleList, { ...formData, id: Date.now() }]);
    }

    const payload = {
      ...formData,
      businessId: businessId,
      loginuserid: userData?.id,
      dayId: moment(formData.date).isoWeekday(),
    };

    const response = await apiHandler({
      method: "POST",
      route: "Business/businessHoursByDateUpsert",
      payload: payload,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      toggleModal();
      prodcutDataListApi();
      getStaffWiseScheduleRefresh();
    } else {
      console.log(response, "data");
    }
  };

  const handleEdit = (id) => {
    const selected = scheduleList.find((item) => item.id === id);
    setFormData(selected);
    setIsOpen(true);
  };

  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        showLoadingAlert(); // Show loader while deleting
        handleDelete(id);
      }
    });
  };

  const showLoadingAlert = () => {
    MySwal.fire({
      title: "Deleting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        MySwal.showLoading(); // Show loading spinner
      },
    });
  };

  const handleDelete = async (id) => {
    let reqobj = {
      ID: id,
      Module: "businessHoursByDate",
    };

    try {
      const response = await apiHandler({
        method: "POST",
        route: "Superadmin/deletebymoduleid",
        payload: reqobj,
      });

      if (response.ResponseCode === "SUCCESS") {
        MySwal.fire({
          title: "Deleted!",
          text: "Your record has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        prodcutDataListApi();
        getStaffWiseScheduleRefresh();
      } else {
        MySwal.fire({
          title: "Error!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      MySwal.fire({
        title: "Error!",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="mb-4">
      <div className="card custome-card-padding rounded-2 mb-4">
        <div className="row g-3 align-items-end">
          <div className="col-12 col-sm-6 col-md-3">
            <label className="fw-bold text-color-70 mb-1">Date</label>
            <DatePickup
              filterDate={formData.date}
              handleDateChange={(e) =>
                handleChange("date", moment(e).format("YYYY-MM-DD"))
              }
            />
          </div>

          <div className="col-12 col-sm-6 col-md-auto d-flex align-items-center mb-2 mb-md-0 pb-1">
            <div className="form-check m-0">
              <input
                type="checkbox"
                id="holidayDayOffCheck"
                checked={formData.isDayOff === 1}
                onChange={(e) =>
                  handleChange("isDayOff", e?.target?.checked ? 1 : 0)
                }
                className="custome-boder form-check-input"
              />
              <label
                htmlFor="holidayDayOffCheck"
                className="fw-bold text-color-70 ms-2 form-check-label"
              >
                Day Off
              </label>
            </div>
          </div>

          {!formData.isDayOff && (
            <>
              <div className="col-6 col-sm-6 col-md-3">
                <label className="fw-bold text-color-70 mb-1">Start Time</label>
                <Select
                  options={minHoursDropdown}
                  value={minHoursDropdown?.find(
                    (el) => el.value === formData.startTime
                  )}
                  onChange={(e) => handleChange("startTime", e.value)}
                />
              </div>

              <div className="col-6 col-sm-6 col-md-3">
                <label className="fw-bold text-color-70 mb-1">End Time</label>
                <Select
                  options={minHoursDropdown}
                  value={minHoursDropdown?.find(
                    (el) => el.value === formData.endTime
                  )}
                  onChange={(e) => handleChange("endTime", e.value)}
                />
              </div>
            </>
          )}

          <div className="col-12 col-md-auto d-flex gap-2">
            <button
              type="button"
              className="btn btn-outline-primary btn-md flex-fill flex-md-grow-0"
              onClick={() => handleBusinessHoursByDateSubmit()}
            >
              {formData.id ? "Update" : "Add New"}
            </button>
            <button
              type="button"
              className="btn btn-primary btn-md btn-wave flex-fill flex-md-grow-0"
              onClick={() => hadleReset()}
            >
              Reset
            </button>
          </div>
        </div>
      </div>

      {/* Responsive Table */}
      <div className="card">
        <div className="table-responsive">
          <table className="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th className="fw-bold text-color-70" style={{ minWidth: "140px" }} scope="col">
                  Date
                </th>
                <th className="fw-bold text-color-70" style={{ minWidth: "100px" }} scope="col">
                  Start Time
                </th>
                <th className="fw-bold text-color-70" style={{ minWidth: "100px" }} scope="col">
                  End Time
                </th>
                <th className="fw-bold text-color-70" style={{ minWidth: "90px" }} scope="col">
                  Day Off
                </th>
                {isDisable === false && (
                  <th className="fw-bold text-color-70" style={{ minWidth: "140px" }} scope="col">
                    Actions
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {scheduleList.map((item) => (
                <tr key={item.id}>
                  <td className="text-color-70">{dateFormat(item.date)}</td>
                  <td className="text-color-70">
                    {item.isDayOff === 1 ? "-" : item.startTime}
                  </td>
                  <td className="text-color-70">
                    {item.isDayOff === 1 ? "-" : item.endTime}
                  </td>
                  <td className="text-color-70">
                    {item.isDayOff === 1 ? "Yes" : "No"}
                  </td>
                  {isDisable === false && (
                    <td>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm me-2"
                        onClick={() => handleEdit(item.id)}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm btn-wave me-2"
                        onClick={() => showConfirmationAlert(item.id)}
                      >
                        Delete
                      </button>
                    </td>
                  )}
                </tr>
              ))}
              {scheduleList.length === 0 && (
                <tr>
                  <td colSpan={isDisable === false ? 5 : 4} className="text-center py-3">
                    No schedules added.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BusinessHoursByDate;
